export const LIGIN_API_URL = {
  logIn: () => `/v1/auth/login`,
  logOut: () => `/v1/auth/logout`,
  changeLogin: () => `/v1/user/change_login`,
  recoveryPassword: () => `/v1/user/recovery_password`,
  changePassword: () => `/v1/user/change_password`,
  refreshToken: () => `/v1/auth/refresh_token`,
  createUser: () => `/v1/user/`,
  updateUserInfo: (email: string) => `/v1/users/${email}`,
  isAuth: () => `/v1/auth/`,
  isUserExist: () => `/v1/auth/email_exists`,
  accountMigration: () => `/v1/user/recovery_password_migrated_user`,
  yandexAutorization: () => `/v1/auth/yandex/login`,
  getYandexAutorizationUser: () => `/v1/auth/exchange`,
};
